<div
  class="cookie-consent-banner"
  *ngIf="visible"
  role="dialog"
  aria-live="polite"
  aria-label="Aviso de cookies"
>
  <div class="cookie-consent-body">
    <div class="cookie-consent-text">
      <strong>Nós utilizamos cookies.</strong>
      <span>
        Pra fazer o app funcionar, lembrar suas preferências e mostrar
        anúncios relevantes que ajudam a manter o Centelha gratuito. Você pode
        ler mais na nossa
        <a routerLink="/privacidade">Política de Privacidade</a>.
      </span>
    </div>

    <div class="cookie-consent-actions">
      <button
        class="cookie-consent-button cookie-consent-button-secondary"
        type="button"
        (click)="reject()"
      >
        Apenas necessários
      </button>
      <button
        class="cookie-consent-button cookie-consent-button-primary"
        type="button"
        (click)="accept()"
      >
        Aceitar todos
      </button>
    </div>
  </div>
</div>
